import React from 'react';
import PropTypes from 'prop-types';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Box, Typography } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { BLACK } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';

const menuItemStyle = { display: 'flex', flexDirection: 'column', alignItems: 'flex-start' };

const PendingStatusMenuButton = ({ status, actions, color }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ alignSelf: 'center' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          cursor: 'pointer',
          fontSize: '14px',
          color: color || BLACK[60],
          fontFamily: PRIMARY_FONT[400],
          lineHeight: '24px',
          letterSpacing: 0,
          verticalAlign: 'middle',
        }}
        onClick={handleClick}
      >
        {status}
        <ArrowDropDownIcon />
      </Box>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {actions
          .filter((action) => action?.text && action?.onClick)
          .map((action, index) => (
            <MenuItem
              key={action?.key ?? action?.id ?? action?.text ?? index}
              onClick={() => {
                handleClose();
                action.onClick();
              }}
              sx={menuItemStyle}
            >
              <Typography>{action.text}</Typography>
            </MenuItem>
          ))}
      </Menu>
    </Box>
  );
};

PendingStatusMenuButton.propTypes = {
  status: PropTypes.string,
  color: PropTypes.string,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      text: PropTypes.string,
      onClick: PropTypes.func,
    })
  ),
};

export default PendingStatusMenuButton;
